import { ChevronDown } from "lucide-react";
import { cn } from "@/utils/stylesUtils";

export function MobileAccordion({ id, open, setOpen, icon, label, children }) {
  const isOpen = open === id;

  return (
    <div className="w-full bg-white rounded">
      <div
        className={cn(
          "flex items-center justify-between w-full px-3 py-3 cursor-pointer",
          isOpen && "bg-[#ECF8FE] font-semibold",
        )}
        onClick={() => setOpen(isOpen ? null : id)}
      >
        <div className="flex items-center gap-2 text-[16px]">
          {icon}
          {label}
        </div>
        <ChevronDown
          size={16}
          className={cn(
            "transition-transform",
            isOpen ? "rotate-180" : "rotate-0",
          )}
        />
      </div>
      {isOpen && children}
    </div>
  );
}
